export function hasPermission(requiredPermissions, permissionEntity) {
    if (!permissionEntity) {
        if (requiredPermissions.length > 0)
            return false;
        return true;
    }
    return requiredPermissions.every((permission) => permissionEntity.permissions.includes(permission));
}
